import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { toString30pk9tzaqopn as toString } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
import {
  toString1pkumu07cwy4m as toString_0,
  getStringHashCode26igk1bx568vk as getStringHashCode,
  hashCodeq5arwsb9dgti as hashCode,
  equals2au1ep9vhcato as equals,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { listOfvhqybd2zx248 as listOf } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/collectionJs.mjs';
import { plus310ted5e4i90h as plus } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import { isBlank1dvkhjjvox3p0 as isBlank } from '../../../../../../kotlin-kotlin-stdlib/kotlin/text/Strings.mjs';
import { toNotBlankString1ovj48s0kinvm as toNotBlankString } from '../../../../../../types-types/kotools/types/text/NotBlankString.mjs';
import {
  throwOnFailure24snjmtlqgzo8 as throwOnFailure,
  _Result___get_value__impl__bjfvqgfu6uyyvgx74d as _Result___get_value__impl__bjfvqg,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/Result.mjs';
import { PlayerId3vdbn0bzxjwb4 as PlayerId } from './PlayerId.mjs';
import { Badge_Default_getInstance2pi5615g7r6x6 as Badge_Default_getInstance } from './Badge.mjs';
import { emptySetcxexqki71qfa as emptySet } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/Sets.mjs';
import { constructCallableReference23y65rf941mch as constructCallableReference } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
function get_defaultPlayer() {
  _init_properties_Player_kt__qi83pd();
  return defaultPlayer;
}
var defaultPlayer;
var PlayerClass;
function Player() {
  if (PlayerClass === VOID) {
    class $ {
      constructor(id, badge, name, email, callSignAdjective, callSignNoun, imageURL, avatarType, additionalEmails) {
        this.w2a_1 = id;
        this.x2a_1 = badge;
        this.y2a_1 = name;
        this.z2a_1 = email;
        this.a2b_1 = callSignAdjective;
        this.b2b_1 = callSignNoun;
        this.c2b_1 = imageURL;
        this.d2b_1 = avatarType;
        this.e2b_1 = additionalEmails;
      }
      w2d(id, badge, name, email, callSignAdjective, callSignNoun, imageURL, avatarType, additionalEmails) {
        return new (Player())(id, badge, name, email, callSignAdjective, callSignNoun, imageURL, avatarType, additionalEmails);
      }
      x2d(id, badge, name, email, callSignAdjective, callSignNoun, imageURL, avatarType, additionalEmails, $super) {
        id = id === VOID ? this.w2a_1 : id;
        badge = badge === VOID ? this.x2a_1 : badge;
        name = name === VOID ? this.y2a_1 : name;
        email = email === VOID ? this.z2a_1 : email;
        callSignAdjective = callSignAdjective === VOID ? this.a2b_1 : callSignAdjective;
        callSignNoun = callSignNoun === VOID ? this.b2b_1 : callSignNoun;
        imageURL = imageURL === VOID ? this.c2b_1 : imageURL;
        avatarType = avatarType === VOID ? this.d2b_1 : avatarType;
        additionalEmails = additionalEmails === VOID ? this.e2b_1 : additionalEmails;
        return $super === VOID ? this.w2d(id, badge, name, email, callSignAdjective, callSignNoun, imageURL, avatarType, additionalEmails) : $super.w2d.call(this, id, badge, name, email, callSignAdjective, callSignNoun, imageURL, avatarType, additionalEmails);
      }
      toString() {
        return 'Player(id=' + this.w2a_1.toString() + ', badge=' + this.x2a_1.toString() + ', name=' + this.y2a_1 + ', email=' + this.z2a_1 + ', callSignAdjective=' + this.a2b_1 + ', callSignNoun=' + this.b2b_1 + ', imageURL=' + this.c2b_1 + ', avatarType=' + toString(this.d2b_1) + ', additionalEmails=' + toString_0(this.e2b_1) + ')';
      }
      hashCode() {
        var result = this.w2a_1.hashCode();
        result = imul(result, 31) + this.x2a_1.hashCode() | 0;
        result = imul(result, 31) + getStringHashCode(this.y2a_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.z2a_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.a2b_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.b2b_1) | 0;
        result = imul(result, 31) + (this.c2b_1 == null ? 0 : getStringHashCode(this.c2b_1)) | 0;
        result = imul(result, 31) + (this.d2b_1 == null ? 0 : this.d2b_1.hashCode()) | 0;
        result = imul(result, 31) + hashCode(this.e2b_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof Player()))
          return false;
        if (!this.w2a_1.equals(other.w2a_1))
          return false;
        if (!this.x2a_1.equals(other.x2a_1))
          return false;
        if (!(this.y2a_1 === other.y2a_1))
          return false;
        if (!(this.z2a_1 === other.z2a_1))
          return false;
        if (!(this.a2b_1 === other.a2b_1))
          return false;
        if (!(this.b2b_1 === other.b2b_1))
          return false;
        if (!(this.c2b_1 == other.c2b_1))
          return false;
        if (!equals(this.d2b_1, other.d2b_1))
          return false;
        if (!equals(this.e2b_1, other.e2b_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'Player');
    PlayerClass = $;
  }
  return PlayerClass;
}
function get_emails(_this__u8e3s4) {
  _init_properties_Player_kt__qi83pd();
  return plus(listOf(_this__u8e3s4.z2a_1), _this__u8e3s4.e2b_1);
}
function get_displayName(_this__u8e3s4) {
  _init_properties_Player_kt__qi83pd();
  // Inline function 'kotlin.text.ifBlank' call
  var this_0 = _this__u8e3s4.y2a_1;
  var tmp;
  if (isBlank(this_0)) {
    tmp = 'Unknown';
  } else {
    tmp = this_0;
  }
  return tmp;
}
var properties_initialized_Player_kt_56shkt;
function _init_properties_Player_kt__qi83pd() {
  if (!properties_initialized_Player_kt_56shkt) {
    properties_initialized_Player_kt_56shkt = true;
    // Inline function 'kotlin.getOrThrow' call
    var this_0 = toNotBlankString('DEFAULT');
    throwOnFailure(this_0);
    var tmp$ret$0 = _Result___get_value__impl__bjfvqg(this_0).u28_1;
    defaultPlayer = new (Player())(new (PlayerId())(tmp$ret$0), Badge_Default_getInstance(), '', '', '', '', null, null, emptySet());
  }
}
function _get_displayName_$ref_dpnhdf() {
  return constructCallableReference((p0) => get_displayName(p0), 1, 0, 21);
}
//region block: exports
export {
  Player as Playerp02wk6dh65n2,
  get_defaultPlayer as get_defaultPlayer3nrcomik61lqf,
  get_emails as get_emails2rmi4cgqmce4k,
  _get_displayName_$ref_dpnhdf as _get_displayName_$ref_dpnhdf3fcfu3lbkbjod,
};
//endregion

//# sourceMappingURL=Player.mjs.map
